import React from 'react';
import IntakeForm from './IntakeForm';

const steps = [
  {
    n: 1,
    title: 'Answer a few questions, and we get you set up',
    body: "Tell us about your business in under three minutes. We take care of the rest, email, website, phone, and the technical setup you'd rather not think about.",
  },
  {
    n: 2,
    title: 'We read your website',
    body: 'Your site already tells us who you are, how you sound, and what you look like. We build from that.',
  },
  {
    n: 3,
    title: 'Agents check each other',
    body: "AI drafts the campaign. Other AI agents review and improve it before anything ships. You can review anything you want, change anything or change nothing. It's up to you.",
  },
  {
    n: 4,
    title: 'A real campaign goes live in your first 7 days',
    body: 'Try it Out. A real campaign goes to your inbox so you can see exactly what your customers will see. Nothing goes to your list until you say so.',
  },
];

export default function Hero() {
  return (
    <section id="top" className="relative pt-8 pb-8 sm:pt-14 sm:pb-10 lg:pt-16 lg:pb-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid lg:grid-cols-12 gap-8 sm:gap-10 lg:gap-12">
        <div className="lg:col-span-7 fade-up">
          <p className="uppercase tracking-[0.16em] text-[11px] sm:text-xs font-semibold mb-4 sm:mb-5" style={{ color: '#5132d4' }}>
            Year 1 free, for the first 1,000 businesses
          </p>
          <h1 className="font-serif text-[2.25rem] leading-[1.06] sm:text-[2.75rem] md:text-5xl lg:text-[3.25rem] xl:text-6xl sm:leading-[1.04] tracking-tight" style={{ color: '#130F28' }}>
            An AI marketing team that <em className="italic" style={{ color: '#5132d4' }}>runs your campaigns all year.</em>
          </h1>

          <p
            data-testid="hero-subhead"
            className="mt-4 sm:mt-5 font-serif text-xl sm:text-2xl md:text-[1.6rem] leading-snug"
            style={{ color: '#1f1c33' }}
          >
            No more wondering what to post or send. Real campaigns, written in your voice, go out every week, all year.
          </p>

          <p className="mt-5 sm:mt-6 text-base sm:text-lg leading-relaxed max-w-2xl" style={{ color: '#3b3656' }}>
            It starts with your website. We use what's already there (your voice, your look, your customers) to build campaigns across email, Instagram, Facebook, and LinkedIn. AI agents draft and review every one so there's room for the work only you can do. No discovery calls, no brand questionnaires, no homework.
          </p>

          <div className="mt-10">
            <h2 id="how-it-works" className="font-serif text-2xl mb-5 scroll-mt-24" style={{ color: '#130F28' }}>How it works</h2>
            <ol className="space-y-4">
              {steps.map((s) => (
                <li key={s.n} className="flex gap-4">
                  <span aria-hidden="true" className="flex-shrink-0 w-9 h-9 rounded-full flex items-center justify-center font-semibold text-white" style={{ backgroundColor: '#6B4BEF' }}>{s.n}</span>
                  <div>
                    <p className="font-semibold" style={{ color: '#130F28' }}>{s.title}</p>
                    <p className="text-sm mt-1" style={{ color: '#3b3656' }}>{s.body}</p>
                  </div>
                </li>
              ))}
            </ol>
          </div>
        </div>

        <div className="lg:col-span-5">
          <div className="lg:sticky lg:top-24 fade-up-delay-2">
            <IntakeForm />
          </div>
        </div>
      </div>
    </section>
  );
}
